import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, of } from 'rxjs';
import { PortalConfig } from '../models/portal-config.models';
import { PortalConfigService } from '../services/portal-config.service';

export const portalConfigResolver: ResolveFn<PortalConfig | null> = () => {
  return inject(PortalConfigService).load().pipe(catchError(() => of(null)));
};
